import { LoaderType } from './types'

export class NetError extends Error {
  retryCount = 0
  isTimeout = false
  loaderType = LoaderType.FETCH

  constructor (url, request, response, msg) {
    super(msg)
    this.url = url
    this.request = request
    this.response = response
  }
}
